import RecentTradesComponent from "src/MarketDataComponents/RecentTrades";

import {formatNumber} from "src/MarketDataComponents/Helpers";
import moment from "moment";

export default function RecentTrades({recentTrades, quote}) {

    const renderTrades = () => {
        const filteredTrades = []; 
        const convertValue = (quote.currency && quote.currency === 'GBX');

        // currently having to extract 5 rows, awaiting for a limit param to graphql
        for (let i = 0; i < 5; i++) {
            if (recentTrades[i]) {
                filteredTrades.push({
                    ...recentTrades[i],
                    date: moment(recentTrades[i].date, "DD-MM-YYYY").format("DD/MM/YYYY"),
                    value: formatNumber((convertValue ? (recentTrades[i].value / 100) : recentTrades[i].value), 2),
                    volume: formatNumber(recentTrades[i].volume, 0),
                    time: moment(recentTrades[i].time, "hh:mm:ss.S").format("hh:mm:ss")
                }); 
            }
        }

        return <RecentTradesComponent defaultTableClassName={'data-table data-table--small data-table--scroll margin-0'} trades={filteredTrades} convertValue={convertValue} />
    }

    return  recentTrades && recentTrades.length ? <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm" id="newsContent">
            <h2 className="card-title" data-testid="recentTradesHeader">Recent trades</h2>
            {renderTrades()}
        </div>
    </div> : null
}